import produce from 'immer'
import {
  CARRIERS_LOAD,
  CARRIERS_LOAD_CONTINUATION,
  CARRIERS_LOAD_SUCCESS,
  CARRIERS_LOAD_FAIL
} from './actions'

const initialState: {
  loading: boolean
  error: any
  carriers: any[]
  continuationToken: string
  hasNextPage: boolean
} = {
  loading: false,
  error: null,
  carriers: [],
  continuationToken: '',
  hasNextPage: false
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case CARRIERS_LOAD: {
        draft.loading = true
        draft.error = null
        draft.carriers = []
        draft.hasNextPage = false
        return
      }
      case CARRIERS_LOAD_CONTINUATION: {
        draft.loading = true
        draft.error = null
        return
      }
      case CARRIERS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.carriers.push(...action.carriers)
        draft.continuationToken = action.continuationToken
        draft.hasNextPage = action.hasNextPage
        return
      }
      case CARRIERS_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
